/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { CalculatorIcon, CurtainIcon, EducationIcon, TimerIcon } from "@/icons";
import Button from "@/components/Button";
import { GotoIcon } from "@/icons/GotoIcon";
import { useTranslation } from "react-i18next";
import "./index.scss";
import { useExtraTool } from "@/contexts/ExtraToolContext";
import { openWebSide } from "@/utility/utils";
import { useNavigate } from "react-router-dom";
import { loadAppSettings, AppSetting } from "@/configs/appSetting";
interface ExtraToolsProps {
  closeSideBar: () => void;
}

const ExtraTools: React.FC<ExtraToolsProps> = ({ closeSideBar }) => {
  const { t } = useTranslation("translation", { keyPrefix: "footer" });
  const navigate = useNavigate();
  const { openCalculator, openStopWatch, openMaskingPage } = useExtraTool();
  const [appSetting, setAppSetting] = useState<AppSetting | null>(null);

  useEffect(() => {
    loadAppSettings().then((cfg) => setAppSetting(cfg));
  }, []);
  const handleButtonClick = (action: () => void) => {
    action();
    closeSideBar();
  };

  return (
    <>
      <div className="extra-tools-page">
        <div className="extra-tools-content">
          <Button onClick={() => handleButtonClick(() => openCalculator())}>
            <div>
              <CalculatorIcon className="margin-right-10" />
              <span className="btn-text"> {t("calculator")}</span>
            </div>
            <GotoIcon />
          </Button>
          <Button onClick={() => handleButtonClick(() => openStopWatch())}>
            <div>
              <TimerIcon className="margin-right-10" />
              <span className="btn-text">{t("stopwatch_timer")}</span>
            </div>
            <GotoIcon />
          </Button>{" "}
          {appSetting?.UseGeoGebra && (
            <Button
              onClick={() => openWebSide("https://www.geogebra.org/calculator")}
            >
              <div>
                <span className="geo-span">∑ </span>
                <span className="btn-text">{t("geogebra")}</span>
              </div>
              <GotoIcon />
            </Button>
          )}
          {appSetting?.UseSimulation && (
            <Button
              onClick={() => handleButtonClick(() => navigate("/phContent"))}
            >
              <div className="margin-right-10">
                <EducationIcon className={undefined} />
                <span className="btn-text">{t("simulations")}</span>
              </div>
              <GotoIcon />
            </Button>
          )}
          <Button onClick={() => handleButtonClick(() => openMaskingPage())}>
            <div className="margin-right-10">
              <CurtainIcon className={undefined} />
              <span className="btn-text">{t("curtain")}</span>
            </div>
            <GotoIcon />
          </Button>
        </div>
      </div>
    </>
  );
};

export default ExtraTools;
